export const styles = theme => ({
  container: {
    maxWidth: 1140,
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: theme.spacing.unit * 8
  },

  emptyBookingsCell: {
    textAlign: 'center'
  }
})



// WEBPACK FOOTER //
// ./src/components/WebsiteBookings/styles.js